<template>
  <div>
    <!-- main-area -->
        <main class="fix">
            <!-- breadcrumb-area -->
            <section class="breadcrumb__area breadcrumb__bg">
                <div class="container">
                    <div class="row mt-5">
                        <div class="col-lg-6">
                            <div class="breadcrumb__content">
                                <h2 class="title">Data Pegawai</h2>
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><a href="javascript:void(0);" @click="$router.push('/')">Beranda</a></li>
                                        <li class="breadcrumb-item active" aria-current="page">Data Pegawai</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="breadcrumb__shape">
                    <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                </div>
            </section>
            <section class="blog_area mt-5">
                <div class="container">
                    <div class="team-item-wrap">
                        <div class="row justify-content-center">
                            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8" v-for="(data) in list_data" :key="data.id">
                                <div class="team-item">
                                    <div class="team-thumb">
                                       <div v-if="data.file == null || data.file == undefined || data.file == '' ">
                                          <img src="assets/img/noImage.png" >
                                       </div>
                                       <div v-else>
                                          <img :src="file_path+data.file" alt="" />
                                       </div>
                                    </div>
                                    <div class="team-content">
                                        <h4 class="title"><a href="javascript:void(0)">{{data.nama}}</a></h4>
                                        <span>{{data.jabatan}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pagination-wrap mt-40">
                     <nav aria-label="Page navigation example">
                        <ul class="pagination list-wrap">
                           <li class="page-item">
                           <a class="page-link" href="javascript:void(0);" @click="btn_prev" id="pref"><i class="fas fa-angle-double-left"></i></a>
                           </li>
                           <!-- <li class="page-item active"><a class="page-link" href="#">1</a></li> -->
                           <li class="page-item"><a class="page-link" href="javascript:void(0);">{{ page_first }}</a></li>
                           <li class=""><a class="page-link border-0" href="javascript:void(0);">-</a></li>
                           <li class="page-item"><a class="page-link" href="javascript:void(0);">{{ page_last }}</a></li>
                           <li class="page-item next-page">
                           <a class="page-link" href="javascript:void(0);" @click="btn_next"><i class="fas fa-angle-double-right"></i></a>
                           </li>
                        </ul>
                     </nav>
                     </div>
                </div>
            </section>
        </main>
  </div>
</template>

<script>

// const ADD_URL = URL_APP + "api/v1/publish_dtphp_data_pegawai/";
// const FILE_LOAD = URL_APP_SIMPEG + "uploads/";


export default {

    data() {
        return {
            data_load : false,
            form : {
                id : '',
                nama : '',
                jabatan : '',
                isi: "",
                judul : '',
                sumber : '',
                deskripsi : '',
                uraian : '',
                foto : '',
                unit_kerja : '',
                status : '',
                keterangan : '',
            },
            id :'',
            file_path: this.$store.state.url.URL_APP_SIMPEG + "uploads/",

            list_data: [],
            page_first: 1,
            page_last: 0,
            cari_value: "",
        }
    },
    methods: {
    getView: function() {
      const a = this.file_path
      console.log(a);
      fetch(this.$store.state.url.URL_DATA_PEGAWAI + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
        })
      })
        .then(res => res.json())
        .then(res_data => {
            this.list_data = res_data.data;
            this.page_last = res_data.jml_data;
            console.log(res_data);
        });
    },

    selectData: function(data) {
        this.form = {
            id : data.id,
            nama : data.nama,
            jabatan : data.jabatan,
            isi : data.isi,
            foto : data.foto,
        };
    },

    mdl_exit: function() {
      this.judul = "";
      this.uraian = "";
      this.file = "";
      this.file_old = "";
    },

    btn_prev : function(){
        if(this.page_first>1){
            this.page_first--
        }else{
            this.page_first = 1;
        }
        this.getView();
    },

    btn_next : function(){
        
        if(this.page_first >= this.page_last){
            this.page_first == this.page_last
        }else{
            this.page_first++;
        }
        this.getView();
    },

  },
  // =============================================================== METHODS =========================================================================

  mounted() {

        this.getView();

    }
};
</script>
